import styled from 'styled-components'
import { BREAKPOINT_QUERIES } from 'styles/breakpoints'

export const WelcomeContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1150px;
  width: 100%;
`

export const WelcomeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 900px;
  width: calc(100% - 16px);

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    width: 100%;
  }
`

export const WelcomeTitle = styled.h1`
  color: ${({ theme }) => theme.colors.neutralW90};
  font-size: 24px;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  max-width: 220px;
  white-space: pre-line;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    font-size: 48px;
    max-width: 480px;
  }
`

export const WelcomeDescription = styled.p`
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 16px;
  line-height: 1.5;
  margin: 0;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    font-size: 24px;
  }
`

export const WelcomeActions = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;

  button {
    flex: 1 1 0;
    min-height: 36px;
    min-width: 0;
  }

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    width: auto;

    button {
      flex: 0 0 auto;
    }
  }
`

export const AddIcon = styled.span`
  align-items: center;
  display: inline-flex;
  height: 16px;
  margin-right: 8px;
  width: 16px;

  svg {
    height: 16px;
    width: 16px;
  }
`

export const ExamplesContainer = styled.div`
  position: relative;
  width: 100%;
`

export const ExampleGrid = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const ExampleCard = styled.article`
  display: flex;
  flex: 0 0 214px;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 214px;

  &:nth-child(5) {
    display: none;
  }

  @media ${BREAKPOINT_QUERIES.desktopUp} {
    &:nth-child(5) {
      display: flex;
    }
  }
`

export const CoverGrid = styled.div`
  aspect-ratio: 1;
  border-radius: 5px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  overflow: hidden;
  width: 100%;
`

export const CoverImage = styled.img`
  height: 100%;
  min-height: 0;
  object-fit: cover;
  width: 100%;

  ${({ $spanColumns }) => $spanColumns && 'grid-column: 1 / -1;'}
`

export const ExampleInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const SongCount = styled.p`
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 12px;
  line-height: normal;
  margin: 0;
`

export const ExampleTitle = styled.h2`
  color: ${({ theme }) => theme.colors.neutralW90};
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const CompactExampleTitle = styled.span`
  display: inline;

  @media ${BREAKPOINT_QUERIES.desktopUp} {
    display: none;
  }
`

export const DesktopExampleTitle = styled.span`
  display: none;

  @media ${BREAKPOINT_QUERIES.desktopUp} {
    display: inline;
  }
`

export const ExamplesFade = styled.div`
  background: linear-gradient(
    180deg,
    rgba(20, 20, 20, 0) 0%,
    rgba(20, 20, 20, 0.86) 74.93%,
    ${({ theme }) => theme.colors.neutralW10} 100%
  );
  height: 274px;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.desktopUp} {
    left: -2px;
    width: calc(100% + 2px);
  }
`
